/**
 * @generated SignedSource<<72272dd9bf311b5ad5f6a1bbec2e57f0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useDisplayInfo_multiskus$data = ReadonlyArray<{
  readonly displayInfo: {
    readonly ctas: {
      readonly showAcceptOffer: boolean | null;
      readonly showFollowCategory: boolean | null;
      readonly showMakeOffer: boolean | null;
      readonly showPurchase: boolean | null;
      readonly showRequestPrice: boolean | null;
    } | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "useDisplayInfo_multiskus";
}>;
export type useDisplayInfo_multiskus$key = ReadonlyArray<{
  readonly " $data"?: useDisplayInfo_multiskus$data;
  readonly " $fragmentSpreads": FragmentRefs<"useDisplayInfo_multiskus">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "useDisplayInfo_multiskus",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        },
        {
          "kind": "Literal",
          "name": "page",
          "value": "pdp"
        }
      ],
      "concreteType": "SkuDisplayInfo",
      "kind": "LinkedField",
      "name": "displayInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CTADisplay",
          "kind": "LinkedField",
          "name": "ctas",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "showPurchase",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "showMakeOffer",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "showRequestPrice",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "showAcceptOffer",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "showFollowCategory",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};

(node as any).hash = "3c8cb9d43717350f0763833c0ea5af5e";

export default node;
